import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';

const GenericDataGrid = (props) => {

  const { rows, columns, rowCount, page, pageSize, onPaginationChange, checkbox, onSelectionChange, loading = false, errors } = props

  return (
    <Box sx={{ width: '100%' }}>
      <div className='dataGridAlignment' >
        <DataGrid
          rows={rows}
          columns={columns}
          pagination
          paginationMode="server"
          rowCount={rowCount}
          paginationModel={{ page, pageSize }}
          onPaginationModelChange={({ page, pageSize }) => onPaginationChange(page, pageSize)}
          checkboxSelection={checkbox === 'true' ? true : false}
          onRowSelectionModelChange={(newSelection) => !loading && onSelectionChange?.(newSelection)}
          disableRowSelectionOnClick
          disableColumnMenu
          pageSizeOptions={[10,20,50]}
          localeText={{
            noRowsLabel: errors || 'Loading...',
            noResultsOverlayLabel: errors,
          }}
          isRowSelectable={() => !loading}
        />
      </div>
    </Box>
  );
};

export default GenericDataGrid;
